const IMPORT_ERRORS = {
  LIMIT_EXCEEDED: '0001'
};

export { IMPORT_ERRORS };
